// extracted by mini-css-extract-plugin
export default {"MealsMenu":"style_MealsMenu__94E00","MealsMenu__error":"style_MealsMenu__error__kUQcy","dataContainer":"style_dataContainer__tjETs"};